import React from 'react';
import styles from './TermsAndCondition.module.scss';

function TermsAndCondition() {
  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.heading1}>Terms & Conditions</h1>
      <div className={styles.contactRow}>
        Move4wd | <a href="mailto:help@wemove4wd.com" className={styles.link}>help@wemove4wd.com</a> | <span>+1 (954) 408-2025</span>
        <span className={styles.modifiedDate}> &nbsp;|&nbsp; Effective Date: October 4, 2025</span>
      </div>

      <h2 className={styles.heading2}>1. Introduction</h2>
      <p className={styles.text}>
        These Terms & Conditions ("Terms") govern your access to and use of services provided by Move4wd LLC ("Move4wd," "we," "us," or "our"), including but not limited to our website, mobile applications, or any related services. By using our services, you agree to be bound by these Terms. If you do not agree, you must discontinue use of our services.
      </p>

      <h2 className={styles.heading2}>2. Services Overview</h2>
      <p className={styles.text}>
        Move4wd provides package shipping solutions, including order fulfillment, and custom brokerage for shipments. We aim to dispatch flexible and fast shipments at a reasonable cost for our target customers. Our offerings include:
      </p>
      <ul className={styles.list}>
        <li>Package shipment and tracking</li>
        <li>Delivery and customs support for your orders</li>
        <li>Customer support via multiple channels</li>
        <li>Online and mobile tools for account management</li>
      </ul>
      <p className={styles.text}>
        We reserve the right to modify, suspend, or discontinue any part of the services, at any time without prior notice.
      </p>

      <h2 className={styles.heading2}>3. Eligibility</h2>
      <p className={styles.text}>
        You must be at least 18 years old and capable of entering into a legal contract. By using Move4wd, you confirm that you meet this requirement and are not legally excluded or restricted from abiding by these agreements.
      </p>

      <h2 className={styles.heading2}>4. User Responsibilities</h2>
      <p className={styles.text}>You agree to:</p>
      <ul className={styles.list}>
        <li>Provide accurate, complete, and current information</li>
        <li>Maintain the security and confidentiality of your account information</li>
        <li>Use our services for lawful purposes only</li>
        <li>Maintain compliance with applicable laws and regulations</li>
      </ul>
      <p className={styles.text}>
        You are responsible for any activity that occurs under your account, including those by persons with which you share login and access.
      </p>

      <h2 className={styles.heading2}>5. Communications & Consent</h2>
      <p className={styles.text}>
        By using our services, you consent to receive SMS or email communications related to your shipments, account activity, and personalized offers. Communications comply with the Florida Telemarketing Act and the Telephone Consumer Protection Act (TCPA).
      </p>
      <ul className={styles.list}>
        <li>You may opt out at any time by replying "STOP" to a text message or "unsubscribe" in an email</li>
        <li>We may send updates and service notices that are essential to your account or service usage</li>
        <li>Your use of the service indicates your consent to receive these messages</li>
      </ul>

      <h2 className={styles.heading2}>6. Payment Terms</h2>
      <p className={styles.text}>
        Move4wd LLC will invoice you for services according to the billing or checkout process agreed. Prices are subject to change without prior notice. You agree to provide and safeguard authorized billing information and to abide by applicable laws.
      </p>
      <p className={styles.text}>
        Payments must be completed in full before shipment is processed. Unpaid or past-due accounts are subject to payment processes.
      </p>

      <h2 className={styles.heading2}>7. Limitation of Liability</h2>
      <ul className={styles.list}>
        <li>Move4wd LLC is not liable for any indirect, incidental, or consequential losses.</li>
        <li>Delays, losses, or damages caused by third-party vendors.</li>
        <li>Your sole remedy for dissatisfaction with our services is to stop using them.</li>
      </ul>
      <p className={styles.text}>
        Our total aggregate liability shall not exceed the amount you have paid for the services. We do not guarantee delivery times or absolute absence of data breaches, or expenses for repairs.
      </p>

      <h2 className={styles.heading2}>8. Data Privacy</h2>
      <p className={styles.text}>
        We are committed to data privacy and comply with all relevant privacy laws. For details on our practices, please see our 
        <a href="/privacy-policy" className={styles.link}>Privacy Policy</a>.
      </p>
      <ul className={styles.list}>
        <li><b>Florida Information Protection Act (FIPA):</b> Data security and notification in the event of a breach.</li>
        <li><b>California Consumer Privacy Act (CCPA):</b> California residents’ privacy rights.</li>
        <li><b>CAN-SPAM Act:</b> Email communications and opt-out rights.</li>
        <li><b>TCPA:</b> SMS and phone consent requirements.</li>
      </ul>

      <h2 className={styles.heading2}>9. Intellectual Property</h2>
      <p className={styles.text}>
        All intellectual property, including logos, text, graphics, software, and trademarks, is the property of Move4wd LLC or its licensors and is protected by law. You may not reproduce, distribute, or use any content without prior written consent.
      </p>

      <h2 className={styles.heading2}>10. Governing Law & Jurisdiction</h2>
      <p className={styles.text}>
        These Terms are governed by the laws of the State of Florida, without regard to conflict of law principles. Any disputes shall be resolved in a state or federal court located in Broward County, Florida, unless otherwise agreed.
      </p>

      <h2 className={styles.heading2}>11. Termination</h2>
      <p className={styles.text}>
        We reserve the right to immediately suspend or discontinue your access to our services at any time, for any reason, including violation of these Terms. Upon termination, your right to use our services will immediately cease.
      </p>

      <h2 className={styles.heading2}>12. Changes to Terms</h2>
      <p className={styles.text}>
        We may update these terms from time to time. Changes will be posted to <a href="/terms-and-conditions" className={styles.link}>wemove4wd.com</a> and are effective when posted. Continued use of our services after changes are posted indicates your acceptance of the updated Terms.
      </p>
      <p className={styles.text}>
        If you have questions, please contact <a href="mailto:help@wemove4wd.com" className={styles.link}>help@wemove4wd.com</a> or call +1 (954) 408-2025.
      </p>
    </div>
  );
}

export default TermsAndCondition;